<template>
	<div class="member">
		<div style="color: #515A6E; font-weight: bold; margin-bottom: 30px;">包含成员</div>
		<div style="display: flex; justify-content: space-between;">
			<div style="width: 33.3%; text-align:center">姓名</div>
			<div style="width: 33.3%; text-align:center">部门</div>
			<div style="width: 33.3%; text-align:center">角色</div>
		</div>
		<div style="display: flex; justify-content: space-between; margin: 20px 0; color: #999999;" v-for="(item,index) in memberList" :key='index'>
			<div style="width: 33.3%; text-align:center">{{item.name}}</div>
			<div style="width: 33.3%; text-align:center">{{item.department_name}}</div>
			<div style="width: 33.3%; text-align:center">{{item.role_name}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"Member",
		props: {
			'memberList': {
				type: Array
			}
		},
		data() {
			return {

			}
		},
	}
</script>

<style scoped lang="less">
	.member{
		width: 500px;
		height: 100%;
		background-color: #FFFFFF;
		margin-left: 10px;
		padding: 20px;
	}

</style>
